import { useRef } from 'react';
import { Pm2Icon } from '@pm2/react-utils';
import { pm2ConfigStore } from '@pm2/store';
import { CircledPlayIcon } from '@ui/kit/icons';
import { PostloadedImage } from '@utils/react';
import { wrapperCls, imageCls, fallbackIconCls, videoWrapperCls } from './thumbnail.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Thumbnail(props) {
  const componentPreviewImage = pm2ConfigStore.useSelector(state => state.config.theme.componentPreviewImage);
  const thumbUrl = props.resource.card?.thumbUrl ?? (props.resource.card?.type === "task" ? componentPreviewImage : undefined);
  const iconRef = useRef(null);
  return /*#__PURE__*/jsxs("div", {
    className: wrapperCls,
    children: [thumbUrl ? /*#__PURE__*/jsx(PostloadedImage, {
      className: imageCls,
      src: thumbUrl,
      sizes: "68px",
      alt: ""
    }) : /*#__PURE__*/jsx("div", {
      ref: iconRef,
      className: fallbackIconCls,
      children: props.resource.icon && /*#__PURE__*/jsx(Pm2Icon, {
        ident: props.resource.icon,
        size: 26
      })
    }), props.resource.card?.type === "video" && thumbUrl && /*#__PURE__*/jsx("div", {
      className: videoWrapperCls,
      children: /*#__PURE__*/jsx(CircledPlayIcon, {
        width: 36
      })
    })]
  });
}

export { Thumbnail };
//# sourceMappingURL=thumbnail.js.map
